import { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  addFilter,
  filter,
  deleteFilter,
  filterAndKeepAll,
  getCollectionProductsNextPage,
  clearAllFilters,
} from "../actions/products-actions/actions";

import { Drawer, Skeleton, Card, Select, Spin, Button } from "antd";
import { useParams, useLocation } from "react-router-dom";
import "../components/CollectionProducts/CollectionProducts.scss";
import { Link, NavLink } from "react-router-dom";
import placeholder_jeans from "../img/placeholder_jeans.svg";

import backArrow from "../img/backArrow.png";
import { history } from "../index";
import { Collapse } from "antd";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { LoadingOutlined, UserOutlined } from "@ant-design/icons";

import "swiper/swiper.min.css";
import "swiper/modules/pagination/pagination.min.css";
import onboarding_img from "../img/onboarding_img.png";
import axiosInstance from "../config/axios-instance";
import { env } from "process";
import { borderRightStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";
import { useQuery } from "react-query";
const { Meta } = Card;
const { Panel } = Collapse;
interface Props {}

export const RepsonsibleChoice = (props: Props) => {
  const location = useLocation();
  const params: any = useParams();

  const [responsible, setResponsible] = useState<Array<any>>([]);
  function useQueryy() {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQueryy();
  const fetchResponsibleChoice = () => {
    let token = localStorage.getItem("token");
    return axiosInstance({
      method: "get",
      url: `/responsible_choice`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }).then((res: any) => {
      setResponsible(res.data);
    });
  };

  const { isLoading, isError, data, error } = useQuery(
    ["companies", query.get("page")],
    () => fetchResponsibleChoice(),
    { keepPreviousData: true }
  );
  useEffect(() => {
    fetchResponsibleChoice();
    console.log(responsible);
  }, [location.pathname]);
  /* 
  return;
  isLoading ? (
    <div className="loading_orders">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <div className="products_page_container">
      <div className={`container-fluid `}>
        <div style={{ padding: "25px" }}>
          <div>
            <div>
              {responsible &&
                responsible.map((el: any) => {
                  return (
                    <div style={{ marginBottom: "25px" }}>
                      <Collapse
                        defaultActiveKey={["1"]}
                        expandIconPosition={"right"}
                        style={{}}
                      >
                        <Panel
                          header={el.name}
                          key="1"
                          id="panel-css"
                          style={{ backgroundColor: "white" }}
                        >
                          <div className="row">
                            <div
                              className="col-3"
                              style={{ textAlign: "left" }}
                            >
                              <p
                                style={{
                                  wordWrap: "break-word",
                                  opacity: "0.5",
                                }}
                              >
                                {el.description || "No description"}
                              </p>
                            </div>
                            <div
                              className="col-9"
                              style={{ wordWrap: "break-word" }}
                            >
                              {" "}
                              <div>
                                <Swiper
                                  slidesPerView={4.5}
                                  spaceBetween={30}
                                  navigation={true}
                                  pagination={false}
                                  className="mySwiper"
                                  style={{ overflow: "hidden" }}
                                >
                                  {el?.products.map((prod: any) => {
                                    return (
                                      <>
                                        <SwiperSlide>
                                          {" "}
                                          <img
                                            src={
                                              process.env
                                                .REACT_APP_STORAGE_URL +
                                              prod.front_image
                                            }
                                            width="100%"
                                            height={"50%"}
                                            style={{
                                              borderColor: "#FAFAFA",
                                            }}
                                          />
                                        </SwiperSlide>
                                      </>
                                    );
                                  })}
                                </Swiper>
                                <div style={{ textAlign: "right" }}>
                                  <Link
                                    to={
                                      "/responsible/" +
                                      el.id +
                                      "/" +
                                      el.fabric_type
                                    }
                                    className="btn"
                                  >
                                    See more
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  ); */

  return isLoading ? (
    <div className="loading_orders">
      <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
    </div>
  ) : (
    <div className="products_page_container">
      <div className={`container-fluid `}>
        <div style={{ padding: "25px" }}>
          <div>
            <div>
              {responsible &&
                responsible.map((el: any) => {
                  return (
                    <div style={{ marginBottom: "25px" }}>
                      <Collapse
                        defaultActiveKey={["1"]}
                        expandIconPosition={"right"}
                        style={{}}
                      >
                        <Panel
                          header={el.name}
                          key="1"
                          id="panel-css"
                          style={{ backgroundColor: "white" }}
                        >
                          <div className="row">
                            <div
                              className="col-4"
                              style={{ textAlign: "left" }}
                            >
                              <div
                                style={{
                                  wordWrap: "break-word",
                                  opacity: "0.5",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: el.description || "No description",
                                }}
                              ></div>
                            </div>
                            <div
                              className="col-8"
                              style={{ wordWrap: "break-word" }}
                            >
                              {" "}
                              <div>
                                <Swiper
                                  slidesPerView={4.5}
                                  spaceBetween={30}
                                  navigation={true}
                                  pagination={false}
                                  className="mySwiper"
                                  style={{ overflow: "hidden" }}
                                >
                                  {el?.products.map((prod: any) => {
                                    return (
                                      <>
                                        <SwiperSlide>
                                          {" "}
                                          <Link
                                            to={`/product/details/${prod.fabric}/${prod.gendre}/${prod.category}/${prod.name}/${prod.id}`}
                                            style={{ textAlign: "center" }}
                                          >
                                            <img
                                              src={
                                                prod.front_image
                                                  ? process.env
                                                      .REACT_APP_STORAGE_URL +
                                                    prod.front_image
                                                  : placeholder_jeans
                                              }
                                              width="100%"
                                              height={"50%"}
                                              style={{
                                                borderColor: "#FAFAFA",
                                              }}
                                            />
                                            <span>
                                              {prod.code}-{prod.name}
                                              <>
                                                {prod.gender_id == 2 ? (
                                                  <>-Women</>
                                                ) : prod.gender_id == 1 ? (
                                                  <>-Men</>
                                                ) : prod.gender_id == 3 ? (
                                                  <>-Unisex</>
                                                ) : prod.gender_id == 4 ? (
                                                  <>-Kids</>
                                                ) : prod.gender_id == 5 ? (
                                                  <>-Boys</>
                                                ) : prod.gender_id == 6 ? (
                                                  <>-Girls</>
                                                ) : (
                                                  ""
                                                )}
                                              </>
                                            </span>
                                          </Link>
                                        </SwiperSlide>
                                      </>
                                    );
                                  })}
                                </Swiper>
                                <div
                                  style={{
                                    marginTop: "20px",
                                    textAlign: "right",
                                  }}
                                >
                                  <Link
                                    to={
                                      "/responsible/" +
                                      el.id +
                                      "/" +
                                      el.fabric_type +
                                      "/" +
                                      el.name
                                    }
                                    className="btn"
                                  >
                                    See more
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Panel>
                      </Collapse>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
